import React from 'react';

import styled from 'styled-components';

const Container = styled.div`

    width:95%;
    margin:auto;
`


export const DetailSection  = () => (
    <Container>




        <h1>
            How It Works? 🧐
        </h1>


        <p>
            Just put the phone number that you want to send a message and click the button, this will redirect to the Whatsapp app with the chat open, is that simple!
        </p>


        <h1>

        Why? 🤔
        </h1>


        <p>

        Sometimes you have to send a message to a phone number and Whatsapp doesn't have you if you don't add a new contact. So I made this simple Web App to solve the problem.
        </p>






    </Container>
)